import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import Container from "reactstrap/lib/Container";
import PropTypes from "prop-types";
import Button from "ComponentsUI/Button";
import { Link } from "react-router-dom";

const useStyles = createUseStyles((theme) => ({
	root: {
		width: "780px",
		height: "100px",
		margin: "0 auto 30px",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		background: `linear-gradient(107.66deg, ${theme.palette.colors.softYellow} -24.45%, ${theme.palette.colors.softYellow} -24.44%, ${theme.palette.colors.vividOrange} 81.96%)`,
		borderRadius: "10px",
	},
	rootStreet: {
		margin: "0 auto 40px",
	},
	text: {
		marginLeft: "50px",
		color: theme.palette.colors.white,
		fontFamily: theme.fonts.bold,
		fontSize: "28px",
		lineHeight: "36px",
	},
	button: {
		margin: "0 50px 0",
		"& a, &:visited, &:hover, &:focus": {
			color: theme.palette.colors.white,
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		root: {
			width: "590px",
			height: "120px",
			margin: "0 auto 20px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			margin: "0 auto 25px",
		},
		text: {
			marginLeft: "20px",
			fontSize: "18px",
			lineHeight: "20px",
		},
		button: {
			margin: "0 20px 0",
		},
	},
}));

const Banner101Rubles = (props) => {
	const { viewBanner, streetStyle, text, bannerLocation, sendingStore } = props;
	const classes = useStyles();
	const onCLickHandler = () => {
		if (bannerLocation === "street") {
			sendingStore.sendMetriksAndSaveArray("CLICK_BAN_OTZYV_STREET");
		} else if (bannerLocation === "house") {
			sendingStore.sendMetriksAndSaveArray("CLICK_BAN_OTZYV_HOUSE");
		}
	};
	if (!viewBanner) {
		return null;
	}
	return (
		<Container>
			<div
				className={classNames(classes.root, {
					[classes.rootStreet]: streetStyle,
				})}
			>
				<span className={classes.text}>{text.leave_review_and_get_101_rubles}</span>
				<Button
					className={classes.button}
					buttonWant={true}
					component={<a href="#fastReview" />}
					onClick={onCLickHandler}
				>
					{text.WANT}
				</Button>
			</div>
		</Container>
	);
};

Banner101Rubles.propTypes = {
	viewBanner: PropTypes.bool,
	streetStyle: PropTypes.bool,
	bannerLocation: PropTypes.string,
};

Banner101Rubles.defaultProps = {
	viewBanner: false,
	streetStyle: false,
	bannerLocation: "",
};

export default Banner101Rubles;
